/**
 * Autogenerated client for `sofa`.
 *
 * This file was generated via `applied gen openapi -s sofa`.
 *
 * Do not modify by hand.
 *
 * Generator version: 0.0.1
 */

import SafeHttpClient from "@oai/safe-http-client";
import { ClientOptions } from "@oai/safe-http-client/types/client";

import { paths } from "./paths";

export class SofaClient extends SafeHttpClient<
  paths & object,
  "",
  "application/json",
  "application/json"
> {
  constructor(baseUrl: string, options?: ClientOptions) {
    super("sofa", baseUrl, "", "application/json", "application/json", options);
  }
}
